import { render, staticRenderFns } from "./VEditor.vue?vue&type=template&id=5d3e6713"
import script from "./VEditor.vue?vue&type=script&lang=ts"
export * from "./VEditor.vue?vue&type=script&lang=ts"
import style0 from "./VEditor.vue?vue&type=style&index=0&id=5d3e6713&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports